/**
 * Liked products — stored in localStorage as a list of product handles.
 * Wires up [data-kamal-like] buttons, the header count badge and the
 * [data-kamal-wishlist-grid] list on the wishlist page.
 */
(function () {
  var KEY = 'kamal-wishlist';

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function sync() {
    var list = read();

    document.querySelectorAll('[data-kamal-like]').forEach(function (btn) {
      var liked = list.indexOf(btn.dataset.kamalLike) !== -1;
      btn.classList.toggle('is-liked', liked);
      btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
    });

    document.querySelectorAll('[data-kamal-wishlist-count]').forEach(function (el) {
      // Only write on change: textContent replaces a child node, which would
      // re-trigger the MutationObserver below and loop forever.
      var text = String(list.length);
      if (el.textContent !== text) el.textContent = text;
      el.hidden = list.length === 0;
    });
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    write(list);
    sync();
    renderGrid();
  }

  function renderGrid() {
    var grid = document.querySelector('[data-kamal-wishlist-grid]');
    if (!grid) return;

    var empty = document.querySelector('[data-kamal-wishlist-empty]');
    var list = read();
    if (empty) empty.hidden = list.length > 0;

    Promise.all(
      list.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      grid.innerHTML = '';
      products.forEach(function (p) {
        if (!p) return;
        var li = document.createElement('li');
        li.className = 'kamal-wishlist__item';

        var a = document.createElement('a');
        a.href = p.url;
        a.className = 'kamal-wishlist__link';
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_533x$1$2');
          img.alt = p.title;
          img.loading = 'lazy';
          a.appendChild(img);
        }
        var title = document.createElement('span');
        title.className = 'kamal-wishlist__title';
        title.textContent = p.title;
        a.appendChild(title);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'kamal-wishlist__remove';
        remove.textContent = 'Remove';
        remove.addEventListener('click', function () {
          toggle(p.handle);
        });

        li.appendChild(a);
        li.appendChild(remove);
        grid.appendChild(li);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-kamal-like]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    toggle(btn.dataset.kamalLike);
  });

  window.addEventListener('storage', function () {
    sync();
    renderGrid();
  });

  // Cards can be re-rendered (filtering, pagination) — re-sync when the DOM changes.
  new MutationObserver(function () {
    sync();
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });

  function init() {
    sync();
    renderGrid();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
